<template>
  <div>
      <input type="text" v-model="search" placeholder="Search for tiles...">
      <div class="tiles_selection">
          <div v-for="tile in search_tiles" :key="tile.path" class="tiles_selection_tile" @click="selectTile(tile)">
              <i :class="'fal fa-' + tile.icon"></i>
              <p style="margin-top:20px;margin-bottom:0;">{{tile.name}}</p>
          </div>
      </div>
  </div>
</template>

<script>
import axios from "axios";
import Config from "../config";

export default {
    data() {
        return {
            search: "",
            tiles: [],
            search_tiles: []
        }
    },
    mounted () {
        this.loadTiles();
    },
    methods: {
        loadTiles() {
            axios.get(Config.DASHBOARD_API_ENDPOINT + "config.php").then(function (response) {
                this.tiles = response.data.tiles.shuffle();
                this.search_tiles = this.tiles.slice(0, 8);
            }.bind(this)).catch(function () {
                this.$router.replace("/management");
            }.bind(this));
        },
        selectTile(selectedTile) {
            document.getElementsByClassName("tiles_selection_tile").forEach(function (tile){
                tile.className = "tiles_selection_tile";
            });
            if (event.target.className === "tiles_selection_tile") {
                event.target.className += " active";
            } else {
                event.target.parentNode.className += " active";
            }
            this.$emit("selectedTile", selectedTile);
        }
    },
    watch: {
        search() {
            if(this.search.trim() === "") {
                this.search_tiles = this.tiles.slice(0, 8);
            } else {
                this.search_tiles = this.tiles.filter(function(tile) {
                    return tile.name.toLowerCase().trim().indexOf(this.search.toLowerCase().trim()) !== -1;
                }.bind(this));
            }
        }
    }
}
</script>

<style>
.tiles_selection {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
}
.tiles_selection_tile {
    padding: 10px;
    width: calc(50% - 20px);
    margin: 10px;
    border: 1px solid black;
    border-radius: 5px;
    cursor: pointer;
}
.tiles_selection_tile.active {
    border: 1px solid rgb(83, 80, 80);
}

@media only screen and (max-width: 900px) {
    .tiles_selection_tile {
        width: calc(100% - 20px);
    }
}

@media (prefers-color-scheme: dark) {
    .tiles_selection_tile {
        border: 1px solid white;
    }
}
</style>